export type ScreenName = 'intro' | 'core' | 'outro';

export const setCurrentScreen = <T>(state: T, {name}: { name: ScreenName }): T => ({
    ...state,
    currentScreen: name,
});